import { config } from "../../config"

export const system = {
  status: () => {
    const base = config.apiUrl + `/system/status`,
      opt = {}

    return { url: base, opt }
  },
}
